export const MuiBadge = {
    styleOverrides: {
        badge: {
            fontSize: "12px",
            fontStyle: "normal",
            lineHeight: "20px",
            letterSpacing: "0.14px",
            paddingRight: "4px",
            paddingLeft: "4px"
        }
    }
};
//# sourceMappingURL=Badge.js.map